// extracted by mini-css-extract-plugin
export default {"board":"KanbanBoard_board__d5nhC"};